<!--
<app-page-title [title]="router.url === '/account/profile' ? 'My Profile' : 'My Orders'" [children]="[{title: 'Account', link: '/account'}, {title: router.url === '/account/profile' ? 'My Profile' : 'My Orders'}]"></app-page-title>

&lt;!&ndash; Page Content&ndash;&gt;
<div class="container padding-bottom-3x mb-2">
  <div class="row">
    <div class="col-lg-4">
      <aside class="user-info-wrapper">
        <div class="user-cover" style="background-image: url(img/user-cover-img.jpg);">
        </div>
        <div class="user-info">
          &lt;!&ndash; <div class="user-avatar">
            <a class="edit-avatar" href="#"></a>
            <img src="img/account/user-ava.jpg" alt="User">
          </div> &ndash;&gt;
          <div *ngIf="user" class="user-data">
            <h4>{{ user?.firstName }} {{ user?.lastName }}</h4>
            <span>{{ user?.email }} <span *ngIf="user?.roles?.admin">(Admin)</span></span>
          </div>
        </div>
      </aside>
      <nav class="list-group">
        <a class="list-group-item" routerLinkActive="active" routerLink="/account/profile">
          <i class="icon-head"></i>Profile
        </a>

        <a class="list-group-item with-badge" routerLinkActive="active" routerLink="/account/orders" href="">
          <i class="icon-bag"></i>Orders
        </a>
      </nav>
    </div>
    <div class="col-lg-8">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

-->


<app-page-title [title]="router.url === '/account/profile' ? 'My Profile' : 'My Orders'" [children]="[{title: 'Account', link: '/account'}, {title: router.url === '/account/profile' ? 'My Profile' : 'My Orders'}]"></app-page-title>

<!-- Page Content -->
<div class="max-w-7xl mx-auto px-6 py-12">
  <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
    <!-- Sidebar -->
    <div class="lg:col-span-1">
<!--
      <aside class="user-info-wrapper bg-white rounded-xl shadow-lg overflow-hidden">
      &lt;!&ndash;  <div class="user-cover h-32 bg-gold bg-opacity-20" style="background-image: url('img/user-cover-img.jpg'); background-size: cover; background-position: center;">
        </div>&ndash;&gt;
        <div class="user-info p-6">
          <div *ngIf="user" class="user-data text-center">
            <h4 class="text-2xl font-serif text-gold mb-2">{{ user?.firstName }} {{ user?.lastName }}</h4>
            <span class="text-gray-600">{{ user?.email }} <span *ngIf="user?.roles?.admin" class="text-xs text-gold font-medium ml-1">(Admin)</span></span>
          </div>
        </div>
      </aside>
-->
      <nav class="mt-6">
        <a class="block px-4 py-3 bg-gray-100 text-gray-800 hover:bg-gold hover:bg-opacity-30 rounded-lg transition duration-300" routerLinkActive="bg-gold text-white" routerLink="/account/profile">
          <i class="icon-head mr-2"></i>Profile
        </a>
        <a class="block px-4 py-3 bg-gray-100 text-gray-800 hover:bg-gold hover:bg-opacity-30 rounded-lg transition duration-300" routerLinkActive="bg-gold text-white" routerLink="/account/orders">
          <i class="icon-bag mr-2"></i>Orders
        </a>
      </nav>
    </div>
    <!-- Main Content -->
    <div class="lg:col-span-3">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
